(function () {
  'use strict';

  var STORAGE_KEY = 'unicare-pricing-access-v1';
  var ACCESS_TTL_SECONDS = 86400;
  var gate = document.querySelector('[data-pricing-access]') || document.body;
  if (!gate) return;

  var openButtons = document.querySelectorAll('[data-pricing-open]');
  var closeButton = gate.querySelector('[data-pricing-close]');
  var overlay = gate.querySelector('[data-pricing-overlay]');
  var dialog = gate.querySelector('[data-pricing-dialog]');
  var form = gate.querySelector('[data-pricing-form]');
  var passwordInput = gate.querySelector('[data-pricing-password]');
  var togglePasswordButton = gate.querySelector('[data-pricing-toggle-password]');
  var submitButton = gate.querySelector('[data-pricing-submit]');
  var errorMessage = gate.querySelector('[data-pricing-error]');
  var lockButtons = document.querySelectorAll('[data-pricing-lock]');
  var pricingApiUrl = String(gate.getAttribute('data-pricing-api-url') || '').replace(/\/+$/, '');
  var cartAttribute = String(gate.getAttribute('data-pricing-cart-attribute') || '_unicare_pricing_access');
  var pricingUnlocked = gate.getAttribute('data-pricing-unlocked') === 'true';
  var cartUnlockedAt = parseInt(gate.getAttribute('data-pricing-unlocked-at'), 10) || 0;
  var lastFocusedElement = null;

  function validAccessTimestamp(value) {
    var unlockedAt = parseInt(value, 10) || 0;
    var now = Math.floor(Date.now() / 1000);
    return unlockedAt > 0 && now >= unlockedAt - 300 && now - unlockedAt < ACCESS_TTL_SECONDS;
  }

  function loadStoredAccess() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (!stored || !validAccessTimestamp(stored.unlockedAt)) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return { unlockedAt: parseInt(stored.unlockedAt, 10) };
    } catch (error) {
      return null;
    }
  }

  function saveStoredAccess(unlockedAt) {
    if (!validAccessTimestamp(unlockedAt)) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ unlockedAt: parseInt(unlockedAt, 10) }));
    } catch (error) {}
  }

  function clearStoredAccess() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
  }

  function showError(message) {
    if (!errorMessage) return;
    errorMessage.textContent = message;
    errorMessage.hidden = false;
    errorMessage.focus();
  }

  function clearError() {
    if (!errorMessage) return;
    errorMessage.textContent = '';
    errorMessage.hidden = true;
  }

  function focusPasswordInput() {
    if (!passwordInput || !dialog || dialog.hidden) return;
    passwordInput.disabled = false;
    passwordInput.removeAttribute('readonly');
    try {
      passwordInput.focus({ preventScroll: true });
    } catch (error) {
      passwordInput.focus();
    }
  }

  function closeMobileNavigation() {
    document.documentElement.classList.remove('show-nav');

    var mobileMenuButton = document.querySelector('.menu-toggle');
    if (mobileMenuButton) mobileMenuButton.setAttribute('aria-expanded', 'false');

    var headerSection = document.getElementById('shopify-section-header');
    var siteHeader = headerSection && headerSection.querySelector('.site-header');
    if (siteHeader) siteHeader.classList.remove('site-header--hidden');

    if (
      window.theme &&
      window.theme.a11y &&
      typeof window.theme.a11y.removeTrapFocus === 'function' &&
      window.jQuery
    ) {
      window.theme.a11y.removeTrapFocus({
        $container: window.jQuery(headerSection),
        namespace: 'mobileMenuToggle'
      });
    } else if (window.jQuery) {
      window.jQuery(document).off('focusin.mobileMenuToggle');
      if (headerSection) headerSection.removeAttribute('tabindex');
    }
  }

  function openDialog() {
    if (!dialog || !overlay) return;
    lastFocusedElement = document.activeElement;
    clearError();
    closeMobileNavigation();
    overlay.hidden = false;
    dialog.hidden = false;
    dialog.removeAttribute('inert');
    dialog.inert = false;
    openButtons.forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
    document.body.classList.add('pricing-access-modal-open');
    window.requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      dialog.classList.add('is-open');
      focusPasswordInput();
    });
    window.setTimeout(focusPasswordInput, 120);
  }

  function closeDialog() {
    if (!dialog || !overlay || dialog.hidden) return;
    overlay.classList.remove('is-open');
    dialog.classList.remove('is-open');
    openButtons.forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('pricing-access-modal-open');
    window.setTimeout(function () {
      overlay.hidden = true;
      dialog.hidden = true;
      dialog.inert = true;
      dialog.setAttribute('inert', '');
    }, 180);
    if (passwordInput) {
      passwordInput.value = '';
      passwordInput.type = 'password';
    }
    if (togglePasswordButton) {
      togglePasswordButton.textContent = 'Show';
      togglePasswordButton.setAttribute('aria-label', 'Show password');
    }
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') lastFocusedElement.focus();
  }

  function shopifyRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function cartUpdate(payload, fallbackMessage) {
    return window.fetch(shopifyRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (cart) {
        if (!response.ok) {
          throw new Error(cart.description || cart.message || fallbackMessage);
        }
        return cart;
      });
    });
  }

  function clearCart() {
    return window.fetch(shopifyRoot() + 'cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Shopify could not reset this pricing session.');
      return response;
    });
  }

  function updatePricingAccess(value, unlockedAt, clearQuoteApproval) {
    var attributes = {};
    attributes[cartAttribute] = value;
    attributes['_unicare_pricing_unlocked_at'] = unlockedAt || '';
    if (clearQuoteApproval) {
      attributes['Unicare Quote ID'] = '';
      attributes['_unicare_approved_quote_id'] = '';
      attributes['_unicare_approved_quote_token'] = '';
      attributes['_unicare_approved_quote_revision'] = '';
    }
    return cartUpdate({ attributes: attributes }, 'Shopify could not update this pricing session.');
  }

  function restorePricingAccessFromBrowser() {
    var storedAccess = loadStoredAccess();

    if (pricingUnlocked) {
      if (validAccessTimestamp(cartUnlockedAt)) saveStoredAccess(cartUnlockedAt);
      return;
    }
    if (!storedAccess) return;

    updatePricingAccess('granted', String(storedAccess.unlockedAt), false).then(function () {
      window.location.reload();
    }).catch(function () {
      // Keep the browser timestamp so a temporary Shopify cart failure can recover on the next page.
    });
  }

  function setSubmitting(isSubmitting, progressLabel) {
    if (!submitButton) return;
    submitButton.disabled = isSubmitting;
    submitButton.textContent = isSubmitting ? (progressLabel || 'Unlocking pricing…') : 'Unlock pricing';
  }

  openButtons.forEach(function (button) { button.addEventListener('click', openDialog); });
  if (closeButton) closeButton.addEventListener('click', closeDialog);
  if (overlay) overlay.addEventListener('click', closeDialog);

  if (togglePasswordButton && passwordInput) {
    togglePasswordButton.addEventListener('click', function () {
      var showPassword = passwordInput.type === 'password';
      passwordInput.type = showPassword ? 'text' : 'password';
      togglePasswordButton.textContent = showPassword ? 'Hide' : 'Show';
      togglePasswordButton.setAttribute('aria-label', showPassword ? 'Hide password' : 'Show password');
      passwordInput.focus();
    });
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearError();

      if (!/^https:\/\//i.test(pricingApiUrl)) {
        showError('The pricing access service is not configured.');
        return;
      }

      setSubmitting(true, 'Checking password…');
      window.fetch(pricingApiUrl + '/api/pricing-access/verify', {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ password: passwordInput ? passwordInput.value : '' })
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.unlocked !== true) {
            throw new Error(data.error || (response.status === 429
              ? 'Too many attempts. Please wait a moment and try again.'
              : 'Incorrect password. Please try again.'));
          }
          var unlockedAt = Number(data.unlockedAt);
          if (!isFinite(unlockedAt) || unlockedAt <= 0) {
            throw new Error('The pricing access service returned an invalid session time. Please try again.');
          }
          return Math.floor(unlockedAt);
        });
      }).then(function (unlockedAt) {
        setSubmitting(true, 'Unlocking pricing…');
        return clearCart().then(function () {
          return updatePricingAccess('granted', String(unlockedAt), true);
        }).then(function () {
          return unlockedAt;
        });
      }).then(function (unlockedAt) {
        saveStoredAccess(unlockedAt);
        try { window.sessionStorage.setItem('unicare-pricing-just-unlocked', String(Date.now())); } catch (error) {}
        window.location.reload();
      }).catch(function (error) {
        setSubmitting(false);
        showError(error.message || 'Pricing could not be unlocked. Please try again.');
        if (passwordInput) {
          passwordInput.select();
          passwordInput.focus();
        }
      });
    });
  }

  lockButtons.forEach(function (lockButton) {
    lockButton.addEventListener('click', function () {
      lockButtons.forEach(function (button) {
        button.disabled = true;
        button.textContent = 'Locking pricing…';
      });
      clearCart().then(function () {
        return updatePricingAccess('', '', true);
      }).then(function () {
        clearStoredAccess();
        window.location.reload();
      }).catch(function () {
        lockButtons.forEach(function (button) {
          button.disabled = false;
          button.textContent = 'Pricing unlocked · Lock';
        });
      });
    });
  });

  restorePricingAccessFromBrowser();

  document.addEventListener('keydown', function (event) {
    if (!dialog || dialog.hidden) return;

    if (event.key === 'Escape') {
      closeDialog();
      return;
    }

    if (event.key === 'Tab') {
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return !element.hidden && element.offsetParent !== null;
      });

      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
